import React from 'react'

export const DocumentTool: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="py-8 text-center">
        <p className="text-sm text-muted-foreground">Document tools coming soon...</p>
      </div>
    </div>
  )
}
